import { Typography, TypographyProps } from '@mui/material'
import React, { ReactNode } from 'react'

type Props = Omit<TypographyProps, 'variant'> & {
  children: ReactNode
  bold?: boolean
}

export const Caption: React.FC<Props> = ({
  sx,
  children,
  bold = false,
  ...typographyProps
}) => {
  const boldProps = bold ? { fontWeight: 'bold' } : {}

  return (
    <Typography
      variant="caption"
      {...typographyProps}
      sx={{
        ...sx,
        ...boldProps,
      }}
    >
      {children}
    </Typography>
  )
}
